import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api.service';

export const fetchDistributors = createAsyncThunk(
  'distributors/fetchDistributors',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getDistributors();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const createDistributor = createAsyncThunk(
  'distributors/createDistributor',
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiService.createDistributor(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const updateDistributor = createAsyncThunk(
  'distributors/updateDistributor',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiService.updateDistributor(id, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

export const deleteDistributor = createAsyncThunk(
  'distributors/deleteDistributor',
  async (id, { rejectWithValue }) => {
    try {
      await apiService.deleteDistributor(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);

const initialState = {
  distributors: [],
  isLoading: false,
  error: null,
  successMessage: null,
};

const distributorsSlice = createSlice({
  name: 'distributors',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDistributors.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDistributors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.distributors = action.payload;
      })
      .addCase(fetchDistributors.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(createDistributor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createDistributor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.distributors.push(action.payload);
        state.successMessage = 'Distributor created successfully';
      })
      .addCase(createDistributor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(updateDistributor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateDistributor.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.distributors.findIndex((d) => d.id === action.payload.id);
        if (index !== -1) {
          state.distributors[index] = action.payload;
        }
        state.successMessage = 'Distributor updated successfully';
      })
      .addCase(updateDistributor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      .addCase(deleteDistributor.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteDistributor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.distributors = state.distributors.filter((d) => d.id !== action.payload);
        state.successMessage = 'Distributor deleted successfully';
      })
      .addCase(deleteDistributor.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccessMessage } = distributorsSlice.actions;
export default distributorsSlice.reducer;
